import Image from 'next/image';
import { Container, Typography } from '@mui/material';

import { styled } from '@mui/material/styles';
import { TrackButton } from 'components/TrackButton';
import { TrackingEvent } from 'lib/tracking/events';

const IdUploadExampleImage =
  'https://images.ctfassets.net/czunsr9k5tc8/3JkRuuggklwRPfK0QpUUZ2/169bcdbfe3e1966eca4903f29809aea8/id-upload-example.webp?h=522&w=525';

const stepsData = [
  {
    step: 1,
    title: 'Eckdaten für den Wunschkredit eingeben',
    text: 'Damit Sie Ihre persönlichen Kreditangebote erhalten, machen Sie zunächst verschiedene Angaben zu Ihrem gewünschten Kredit.',
  },
  {
    step: 2,
    title: 'Kreditangebote erhalten',
    text: 'Sie erhalten individuelle Kreditangebote von verschiedenen Banken und können sich für das für Sie beste Angebot entscheiden.',
  },
  {
    step: 3,
    title: 'Kreditantrag abschließen',
    text: 'Dank unserem digitalen Antragsprozess können Sie die erforderlichen Unterlagen für Ihren Kredit einfach online hochladen und den Antrag so abschließen.',
  },
];

const CTAContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(8),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    padding: theme.spacing(4),
  },
}));

const ColoredBackground = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
}));

const ContentSplit = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(13),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

const Steps = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(3),
}));

const Number = styled('div')(({ theme }) => ({
  background: '#c5e8c7',
  borderRadius: theme.spacing(1.5),
  width: '40px',
  height: '40px',
  flexShrink: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 500,
  zIndex: 1,
}));

const TextWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderLeft: '2px dashed #75c47f',
  paddingLeft: theme.spacing(5.6),
  marginLeft: theme.spacing(-5.6),
  paddingBottom: theme.spacing(2),
}));

const Step = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  '&:last-of-type': {
    '& > *': {
      borderColor: 'transparent',
    },
  },
}));

const CTAButton = styled(TrackButton)(({ theme }) => ({
  margin: '10px 0 0 0',
  padding: '12px 60px',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    margin: 0,
  },
}));

const ImageBlock = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    order: 1,
  },
}));

const IdentImageDesktop = styled('div')(({ theme }) => ({
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export type CTAStepExplanationsProps = {
  headline: string;
};
export default function CTAStepExplanations({
  headline,
}: CTAStepExplanationsProps) {
  return (
    <ColoredBackground>
      <CTAContainer maxWidth="lg">
        <ContentSplit>
          <ImageBlock>
            {headline && <Typography variant="h2">{headline}</Typography>}
            <Steps>
              {stepsData.map((stepData) => (
                <Step key={stepData.step}>
                  <Number>{stepData.step}</Number>
                  <TextWrapper>
                    <Typography variant="h2">{stepData.title}</Typography>
                    <Typography variant="body2">{stepData.text}</Typography>
                  </TextWrapper>
                </Step>
              ))}
            </Steps>
            <CTAButton
              trackingEvent={TrackingEvent.STEPEXPLANATION_BUTTON_ONINTERACT}
              variant="contained"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              Jetzt Kreditvergleich starten
            </CTAButton>
          </ImageBlock>
          <IdentImageDesktop>
            <Image
              src={IdUploadExampleImage}
              alt="Identifizierung deiner Person"
              width="525"
              height="522"
            />
          </IdentImageDesktop>
        </ContentSplit>
      </CTAContainer>
    </ColoredBackground>
  );
}
